import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const getSocket = () => socket;

export const connectSocket = (url: string, options: any) => {
  if (socket) {
    closeSocketConnection();
  }

  // Extract token and device_code from options
  const { token, device_code, ...socketOptions } = options;

  // Create socket with auth instead of query params
  socket = io(url, {
    ...socketOptions,
    auth: {
      token: token,
      device_code: device_code
    }
  });

  return socket;
};

export const closeSocketConnection = () => {
  if (socket) {
    console.log("Socket is disconnected");
    socket.disconnect();
    socket = null;
  }
};
